import { useSchedulingQuery as useQuery } from "./useSchedulingQuery";
import { listAllBlocks } from "../../components/api/Scheduling/blocks";
import { onError } from "./onError";

export const calendarBlockKeys = {
  list: (organizationRef, filters) => ["scheduling-blocks", organizationRef, filters],
};

export function useCalendarBlocksQuery({
  organizationRef,
  scheduleId,
  practitionerRef,
  startsAt,
  endsAt,
  status = "active",
  onSuccess,
  enabled = true,
}) {
  const filters = { scheduleId, practitionerRef, startsAt, endsAt, status };
  return useQuery(
    calendarBlockKeys.list(organizationRef, filters),
    ({ signal, consistency }) => listAllBlocks({ organizationRef, ...filters, limit: 500, signal, consistency }),
    {
      enabled: !!organizationRef && enabled,
      keepPreviousData: false,
      staleTime: 30000, refetchOnWindowFocus: false, retry: false,
      onSuccess,
      onError,
    }
  );
}
